export default __webpack_public_path__ + "static/media/crop.e03d8e83.svg";